import React from 'react'
import cn from 'classnames'
import styles from './Footer.module.sass'
import Image from '../Image'
import Group from './Group'

const items = require('../../config/' + (process.env.REACT_APP_FOOTER_MENU_JSON ?? 'footer.menu.default.json'))
const socials = []

if (process.env.REACT_APP_SOCIAL_LINKEDIN) {
  socials.push(
    {
      title: 'linkedin',
      url: 'https://www.linkedin.com/company/' + process.env.REACT_APP_SOCIAL_LINKEDIN,
      viewBox: '0 0 16 16'
    },
  )
}

if (process.env.REACT_APP_SOCIAL_MEDIUM) {
  socials.push(
    {
      title: 'medium',
      url: 'https://medium.com/' + process.env.REACT_APP_SOCIAL_MEDIUM,
      viewBox: '0 0 24 24'
    },
  )
}

if (process.env.REACT_APP_SOCIAL_FACEBOOK) {
  socials.push(
    {
      title: 'facebook',
      url: 'https://www.facebook.com/' + process.env.REACT_APP_SOCIAL_FACEBOOK,
      viewBox: '0 0 16 16'
    },
  )
}

if (process.env.REACT_APP_SOCIAL_TWITTER) {
  socials.push(
    {
      title: 'twitter',
      url: 'https://twitter.com/' + process.env.REACT_APP_SOCIAL_TWITTER,
      viewBox: '0 0 16 16'
    },
  )
}

if (process.env.REACT_APP_SOCIAL_TELEGRAM) {
  socials.push(
    {
      title: 'telegram',
      url: 'https://t.me/' + process.env.REACT_APP_SOCIAL_TELEGRAM,
      viewBox: '0 0 26 26'
    },
  )
}

if (process.env.REACT_APP_SOCIAL_INSTAGRAM) {
  socials.push(
    {
      title: 'instagram',
      url: 'https://www.instagram.com/' + process.env.REACT_APP_SOCIAL_INSTAGRAM,
      viewBox: '0 0 16 16'
    },
  )
}

const Footers = () => {
  /*  const [email, setEmail] = useState("");

    const handleSubmit = (e) => {
      alert();
    };*/

  return (
    <footer className={styles.footer}>
      <div className={cn('container', styles.container)}>

        <div className={styles.row}>
          <div className={styles.col}>
            <a className={styles.logo} href="/" target="_blank">
              <Image
                className={cn(styles.pic, 'mobile-hide')}
                src={'/themes/' + process.env.REACT_APP_THEME_IMAGE_FOLDER + '/logo.png'}
                srcDark={'/themes/' + process.env.REACT_APP_THEME_IMAGE_FOLDER + '/logo-dark.png'}
                alt={process.env.REACT_APP_TITLE}
              />

              <Image
                className={cn(styles.pic, 'mobile-show')}
                src={'/themes/' + process.env.REACT_APP_THEME_IMAGE_FOLDER + '/logo.png'}
                srcDark={'/themes/' + process.env.REACT_APP_THEME_IMAGE_FOLDER + '/logo-dark.png'}
                alt={process.env.REACT_APP_TITLE}
              />
            </a>
            <div className={styles.info}>Discover and Collect <br/>Amazing New NFTs</div>
            {/*<div className={styles.version}>
             <div className={styles.details}>Dark theme</div>
             <Theme className="theme-big" />
             </div>*/}
          </div>
          <div className={styles.col}>
            {items.map((x, index) => (
              <Group className={styles.group} item={x} key={index}/>
            ))}
          </div>
          {/*<div className={styles.col}>
           <div className={styles.category}>Join Newsletter</div>
           <div className={styles.text}>
           Subscribe our newsletter to get more free design course and
           resource
           </div>
           <Form
           className={styles.form}
           value={email}
           setValue={setEmail}
           onSubmit={() => handleSubmit()}
           placeholder="Enter your email"
           type="email"
           name="email"
           />
           </div>*/}
        </div>

        <div className={styles.foot}>

          <div className={styles.footer_logo_menu}>
            <div>
              <p>© 2023 QBEIN LLC</p>
            </div>
            {/*<div className={styles.menu}>
              <Link className={styles.link} to="/search">
                Discover
              </Link>
              <Link className={styles.link} to="/upload-details">
                Create item
              </Link>
              <Link className={styles.link} to="/profile">
                Profile
              </Link>
            </div>*/}
          </div>


          <div className={styles.follow}>
            <div className={styles.socials}>
              {socials.map((x, index) => (
                <a
                  className={styles.social}
                  href={x.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={index}
                >
                  <img src={`/images/content/icons/social/${x.title}.svg`} alt=""/>
                  {/*<Icon name={x.title} size="24" viewBox={x.viewBox}/>*/}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footers
